var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEkg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.24414,
    y: 3,
    width: 54,
    height: 55,
    rx: 10,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.2441 5H16.2441C10.169 5 5.24414 9.92487 5.24414 16V44C5.24414 50.0751 10.169 55 16.2441 55H44.2441C50.3193 55 55.2441 50.0751 55.2441 44V16C55.2441 9.92487 50.3193 5 44.2441 5ZM16.2441 0C7.40759 0 0.244141 7.16344 0.244141 16V44C0.244141 52.8366 7.40758 60 16.2441 60H44.2441C53.0807 60 60.2441 52.8366 60.2441 44V16C60.2441 7.16344 53.0807 0 44.2441 0H16.2441Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.24414 40.3478C6.24414 40.3478 5.74414 47 7.24414 47C8.74414 47 8.24414 40 10.2441 40C12.2441 40 10.7441 45 13.2441 45C15.7441 45 17.2441 13 19.2441 13C21.2441 13 21.2441 42.2609 22.7441 43C24.2441 43.7391 25.7441 34.913 28.7441 41C31.7441 47.087 31.2441 35.5435 33.2441 35.5435C35.2441 35.5435 33.7441 39.2391 36.2441 39.2391C38.7441 39.2391 40.2441 35 42.7441 35C45.2441 35 46.7441 39.2391 46.7441 39.2391C47.7441 40.3551 51.4441 41.1783 52.2441 35.5435C53.0441 29.9087 56.2441 40.3478 56.2441 40.3478",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8378 30C47.9366 24.2508 53.3778 15.5606 48.2891 10.8357C43.2004 6.11078 38.8378 11.9988 38.8378 11.9988C38.8378 11.9988 34.2496 6.11078 29.1609 10.8357C24.0722 15.5606 29.7391 24.2508 38.8378 30Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEkg);
export default __webpack_public_path__ + "static/media/ekg.d4c1ff0b262915b10269ef7944bb0b58.svg";
export { ForwardRef as ReactComponent };